<template>
  <div :class="['table-layout-row']">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Row',
  mounted () {
    this.onMounted()
  },
  methods: {
    /**
     * Handler for the mounted callback of the component
     * @method onMounted
     * @return {void}
     */
    onMounted () {
      if (!this.$parent.$el.classList.contains('table-layout')) {
        console.warn('The <row /> element should be nested inside a <table-layout /> component.')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/table-layout/row.vue